import ColoringPageButton from "./ColoringPageButton";

export default ColoringPageButton;